import { Badge, BadgeType } from "../../../../components/badge/badge";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import { FONT_VARIANT } from "../../../../components/fonts/font-props";
import "./locale-container.scss";

const images = import.meta.glob<{ default: string }>('../../../../images/*.svg', { eager: true });

interface ILocaleContainerProps {
    localeName: string,
    isNewLocale: boolean,
}

const LocaleContainer: React.FC<ILocaleContainerProps> = ({localeName = "no-flag", isNewLocale}): JSX.Element => {
    const imageSrc = () => {
            try {
                return images[`../../../../images/${localeName}.svg`].default;
            }
            catch(err) {
               return images[`../../../../images/no-flag.svg`].default;
            }
        };
    
    return (
            <div className="locale-container">
                <img className="flag-icon" alt={`${localeName}-flag`} src={imageSrc()} />
                <FontBody2 variant={FONT_VARIANT.BOLD}>
                    {localeName}
                </FontBody2>
                {isNewLocale &&
                    <Badge text="New" type={BadgeType.PRIMARY} />
                }
            </div>
        )
    
};

export default LocaleContainer;
